import React, {memo} from 'react';
import {Bar} from "react-chartjs-2";
import {ChartData, ChartOptions} from "chart.js";
import {formatNumber, sumArrayData} from "../../../../components/helpers";

const MultipleBarChart = memo((
  {
    month,
    total,
    thickness = 25,
    height,
    fontSize = 11,
  }: {
    month: string[],
    total: any,
    thickness?: number,
    height?: any,
    fontSize?: number,
  }) => {
  const labels = ["Remorquage TTC", "Gardiennage TTC", "Autres frais TTC"];
  const colors = ["#FF3342FF", "#d05f6f", "#3f3e41"];

  const totalData = total.map((data, key: number) => ({
    label: labels?.[key] || '',
    data: data,
    backgroundColor: colors?.[key] || "#939393",
    hoverBackgroundColor: colors?.[key] || "#939393",
    barThickness: thickness,
  })).sort((data1, data2) => sumArrayData(data1.data) - sumArrayData(data2.data));

  const barData: ChartData<any> = {
    labels: month,
    datasets: totalData,
  };

  const barOptions: ChartOptions<any> = {
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 15,
      },
    },
    interaction: {mode: "index", intersect: false},
    scales: {
      x: {
        ticks: {
          font: {
            size: fontSize
          }
        },
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        stacked: true,
        ticks: {
          font: {
            size: fontSize
          },
          stepSize: 100000,
          callback: function (value: number) {
            return formatNumber(this?.getLabelForValue(value)) + ' €';
          },
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {boxWidth: 12}
      },
      tooltip: {
        callbacks: {
          label: function (items) {
            const label = items?.dataset?.label;
            const value = formatNumber(items?.raw);
            return `${label}: ${value} €`;
          },
          footer: (items) => {
            const total = formatNumber(sumArrayData(items?.map(item => item?.dataset?.data[item?.dataIndex])));
            return `Total : ${total} €`;
          }
        }
      },
    },
  };

  const totalPlugin = {
    id: 'totalPlugin',
    afterDatasetsDraw: (chart) => {
      const {ctx, data, scales} = chart;
      data.labels.forEach((_, i) => {
        let total = 0;
        chart.data.datasets.forEach((dataset, index) => {
          const meta = chart.getDatasetMeta(index);
          if (!meta.hidden) total += dataset.data[i] || 0;
        });
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        ctx.fillStyle = '#444';
        ctx.font = 'small 12px Arial';
        ctx.fillText((total !== 0) ? `${formatNumber(total)} €` : '', scales.x.getPixelForValue(i), scales.y.getPixelForValue(total) - 1);
        ctx.restore();
      });
    }
  };

  return <Bar data={barData} options={barOptions} height={height} plugins={[totalPlugin]}/>;
});

export default MultipleBarChart;